import React from "react";


const FiltroEse = ({filtro, setFiltro}) => {
  
  const onChangeTexto = (event) => {
    
    const valor = event.target.value.toString().toLowerCase().trim();
    
    const filtroNew = {...filtro};
    filtroNew.texto = valor;
    setFiltro(filtroNew)
  };
  
  
  return (
    <div className="is-flex m10L">
      
      <div className="m10L p5T m10R">
        <i className="fa fa-filter iconFilter"/>
      </div>
      
      <div className="control">
        <input className="input is-primary"
               onChange={onChangeTexto}
               type="text" placeholder="Buscar por texto"/>
      </div>
    
    
    </div>
  
  );
}

export default FiltroEse;